import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, Renderer2, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../../../base/shared/services/base.service';
import { LoaderService } from '../../../base/services/loader.service';
import { AlertsService } from '../../../base/services/alerts.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { SmartModalService, ModalSize } from 'src/modules/base/services/smart-modal.service';
import { TncComponent } from 'src/modules/base/components/tnc/tnc.component';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UtilService } from 'src/modules/base/services/util.service';
import { LoginServiceService } from '../service/login-service.service';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { DemographicOtpVerifyComponent } from 'src/modules/kx-shared/components/demographic-otp-verify/demographic-otp-verify.component';
import { ADService } from 'src/app/ad.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = ''; login_id_placeholder: string = ""; password_placeholder: string = "";
  eye: string = "fa-eye";
  isKarexpert: string = '';
  headerInfo: any = { showDefaultLogo: false };
  config: any = { loading: false, isADredirect: false, adType: "", loginWithOther: false, isPatient: true };
  eulaList: any = false;
  registerUser: boolean = false;
  showInstallBtn: boolean;
  isAppStatusChecked: boolean = false;
  appStatus: boolean = true;
  checkPattern: any = '^[a-zA-Z0-9!@#$&()\\-`.+_,/\"-]*$';
  logInWithMobile: boolean = false;
  navigator: string; //showLoginForm: boolean = false;
  navPlatform: string;
  superApps: Array<any>[];
  mfa: any = false;
  show_captcha:Boolean = false
  mfaConfig: any = {
    allowNumbersOnly: true,
    length: 4,
    type:'tel',
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputType: 'text',
    inputStyles: {
      'width': '40px',
      'height': '40px'
    }
  }
  otp: any;
  timer: number;
  showTimer: boolean = false;
  resendOTPVar: boolean = false;
  registerConfig: any = {};
  isCapsLockOn: boolean = false;
  logInWith: string;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private baseService: BaseService,
    private storageService: StorageService,
    private loader: LoaderService,
    private alerts: AlertsService,
    private authenticationService: AuthenticationService,
    public appService: AppService,
    public utilService: UtilService,
    private translateService: TranslateService,
    private modalService: SmartModalService,
    private domSanitizer: DomSanitizer,
    public changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public loginservice: LoginServiceService,
    public dialogService: DialogService,
    public adService: ADService,
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {
    this.loginservice.initService()
  }
  
  ngOnInit() {

    this.superApps = this.appService._currentSessionData.superApps;

    /************ AD IMPLIMENATION ********/
    if (this.route.snapshot.data.isADredirect != undefined && this.route.snapshot.data.isADredirect) {
      this.config.isADredirect = this.route.snapshot.data.isADredirect;
      this.config.adType = this.route.snapshot.data.adType;
    }
    this.adService.initloginWithAD((adResp) => {
      if (adResp) {
        if (!this.config.isADredirect) {
          this.removeAdObj();//to avoid conflict with other AD login         
        }
        if (this.config.isADredirect && this.config.adType != "") {
          if (this.config.adType == 'OAuth2') {
            this.processOAuth2Redirect();
          } else {
            this.initloginWithAD();
          }
        }
      }
    });
    /************ AD IMPLIMENATION ********/

    this.headerInfo = this.appService.getAppHeader();
    if (this.headerInfo.default_login_logo_needed != undefined && this.headerInfo.default_login_logo_needed) {
      this.headerInfo.showDefaultLogo = false;
    }
    else {
      this.headerInfo.showDefaultLogo = true;
    }

    if (this.headerInfo.eula_document_links != undefined && this.headerInfo.eula_document_links.length > 0) {
      this.appService.parseEula(this.headerInfo.eula_document_links);
      this.eulaList = this.appService.getEula();
    }

    this.headerInfo.login_tag = this.headerInfo.login_tag.changingThisBreaksApplicationSecurity == undefined ? this.sanitizer.bypassSecurityTrustHtml(this.headerInfo.login_tag) : this.headerInfo.login_tag;
    if (this.headerInfo.android_app_url != undefined) {
      this.headerInfo.android_app_url = this.domSanitizer.bypassSecurityTrustUrl(this.headerInfo.android_app_url);
    }
    if (this.headerInfo.ios_app_url != undefined) {
      this.headerInfo.ios_app_url = this.domSanitizer.bypassSecurityTrustUrl(this.headerInfo.ios_app_url);
    }

    if (this.utilService.getWidth() < 768 && this.headerInfo.mobile_banner != "") {
      this.headerInfo.banner = this.headerInfo.mobile_banner;
    }

    if(this.baseService.checkKioskApp() && this.headerInfo.kiosk_banner){
      this.headerInfo.banner = this.headerInfo.kiosk_banner;
    }

    if(this.baseService.checkKioskApp()){
      this.translateService.translateSync("placeholder.kiosk_login_id").then(res=>{
        this.login_id_placeholder = res;
      });
      this.translateService.translateSync("placeholder.kiosk_password").then(res=>{
        this.password_placeholder = res;
      });
    }

    this.baseService.setFavIcon();
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    const _subdomain = window.location.hostname.substring(0, window.location.hostname.indexOf('.'));
    const _consoleKeys = ['karexpert', 'console', 'adminconsole', 'himsconsole'];
    if (!_consoleKeys.includes(_subdomain) && window.location.hostname != 'localhost' && window.location.hostname.indexOf('admin.dvc.') == -1) {
      this.loginForm = this.formBuilder.group({
        login_id: ['', Validators.required],
        password: ['', Validators.required],
        captcha: [''],
        account_url: ['']
      });
    } else {
      this.isKarexpert = 'karexpert';
      this.loginForm = this.formBuilder.group({
        login_id: ['', Validators.required],
        password: ['', Validators.required],
        captcha: [''],
        account_url: ['', Validators.required]
      });
      /************ CREDENTIAL ARE NOT SUPPOSED TO BE HARDCODE HERE FOR AUTOFILLING ******
       * PLEASE DON'T ADD IT, ITS A SECURITY BREACH
       * 
      *****/

    }
    if (this.headerInfo.additional_authentication_required) {
      this.getCaptcha()
    }
    if (this.route.snapshot.url[1] != undefined && (this.route.snapshot.url[1].path == 'loginwithotp')) {
      this.logInMobile()
    }

    if(this.route.snapshot.url[1] != undefined && (this.route.snapshot.url[1].path == 'loginwithotpkiosk')) {
      this.logInMobileKiosk()
    }
    if (this.route.snapshot.url[1] != undefined && this.route.snapshot.url[1].path == 'loginwithpin') {
      this.logInPin()
    }
    if (this.route.snapshot.url[1] != undefined && this.route.snapshot.url[1].path == "termsandcondition")
      this.showTnc()
  }
  get f() { return this.loginForm.controls; } // return form

  ngAfterViewInit() {
    //for safari in mobile
    if (this.utilService.isiOS() || this.utilService.isFireFox()) {
      this.isAppStatusChecked = true;
      this.changeDetectorRef.detectChanges();
      if (this.utilService.isMobile()) {
        this.showInstallBtn = true;
      }
      else {
        this.showInstallBtn = false;
      }

    }

    if (!this.appService.checkNativeApp()) {
      this.showInstallBtn = this.loginservice.isInstallable();
      console.log("inside showinstall", this.loginservice.isInstallable());
      this.changeDetectorRef.detectChanges();



      if (!this.showInstallBtn) {
        this.isAppStatusChecked = true;
      }


      window.addEventListener('beforeinstallprompt', e => {
        this.showInstallBtn = this.loginservice.isInstallable();
        this.isAppStatusChecked = true;
        this.changeDetectorRef.detectChanges();
        console.log("App installable", this.showInstallBtn);
      });
    } else {
      console.log("insidenative==>YES");
      this.showInstallBtn = false;
      this.isAppStatusChecked = true;
    }

    if (this.baseService.checkKioskApp()) {
      if (this.router.url.includes("loginwithotpkiosk")) {
        this.appService.delete_cookie("is_kiosk");
        this.appService.writeCookie("is_otpkiosk", "true", 1);
      } else {
        this.appService.delete_cookie("is_otpkiosk");
        this.appService.writeCookie("is_kiosk", "true", 1);
      }
    } else {
      this.appService.delete_cookie("is_otpkiosk");
      this.appService.delete_cookie("is_kiosk");
    }
    //added as we don't need to show button in case of app
    if (this.utilService.isPwa()) {
      this.isAppStatusChecked = true;
      this.showInstallBtn = false;
    }
    let packageName = this.appService._currentSessionData['header'] != undefined && this.appService._currentSessionData['header']['app_package'] != undefined ? this.appService._currentSessionData['header']['app_package'] : "";
    console.log("referrer is", document.referrer);
    if (packageName && document.referrer.includes('android-app://' + packageName)) {
      this.isAppStatusChecked = true;
    }


    //after 30 secs if beforeinstallprompt then hide the check status button
    setTimeout(() => {
      this.isAppStatusChecked = true;
      this.changeDetectorRef.detectChanges();
    }, 30000)
  }

  ngOnDestroy() {
    this.loginservice.disconnectCaptchaObserver();
  }

  resendOTP() {
    this.resendOTPVar = true;
    this.onSubmit();
    //this.alerts.success('Request Successful');
  }

  checkurl() {
    return this.route.snapshot.url[1] != undefined && (this.route.snapshot.url[1].path == 'loginwithotp' || this.route.snapshot.url[1].path == 'loginwithpin' || this.route.snapshot.url[1].path == 'loginwithotpkiosk');
  }

  onSubmit() { // onsubmit click
    if (this.config.loading) {
      return;
    }
    var account_url;
    if (!this.isKarexpert) {
      account_url: [window.location.hostname]

    }
    this.loader.showSpinner();
    this.submitted = true;
    var loginInfo = {};
    // stop here if form is invalid
    if (!this.config.isADredirect) {
      if (this.loginForm.invalid) {
        this.loader.hideSpinner();
        return;
      }
    }

    this.config.loading = true;

    if (this.isKarexpert != '') {
      loginInfo = this.loginForm.value;
    } else {
      loginInfo['account_url'] = window.location.hostname;
      loginInfo['login_id'] = this.loginForm.controls['login_id'].value;
      loginInfo['password'] = this.loginForm.controls['password'].value;
      loginInfo['captcha'] = this.loginForm.controls['captcha'].value;
    }
    if (!this.headerInfo.additional_authentication_required) {
      delete loginInfo['captcha'];
    }
    if (loginInfo['account_url'].includes("enterprise.k")) {
      loginInfo['super_app'] = "crm"; //Hardcoded for CRM Enterprise
    }
    else {
      loginInfo['super_app'] = this.appService.getDefaultApp()?this.appService.getDefaultApp():this.appService._appData.DEFAULT_APP;//it could be make a select instead of default
    }
    if (this.otp && this.mfa && !this.resendOTPVar) {
      loginInfo['password'] = this.otp;
      let obj = {
        "otpLogin": this.mfa == 'otp' ? true : false,
        "pinLogin": this.mfa == 'pin' ? true : false,
        "mfaLogin": this.mfa ? true : false
      }
      loginInfo['extra_data'] = obj;
    }
    if (this.resendOTPVar) {
      loginInfo['password'] = this.loginForm.controls['password'].value;
      delete this.loginForm.value.extra_data;
    }
    if (this.headerInfo.main_account != undefined && this.headerInfo.main_account.account_url != undefined && this.headerInfo.main_account.account_url && this.isKarexpert != 'karexpert') {
      loginInfo['account_url'] = this.headerInfo.main_account.account_url;
      this.storageService.setData("MAIN_ACCOUNT", this.headerInfo.main_account, () => { });
    }
    loginInfo = this.loginservice.encrypt(loginInfo);
    var isPatient = localStorage.getItem("ad_patient");
    if (this.config.isADredirect) {
      loginInfo['is_ad'] = true;
      loginInfo['ad_type'] = this.config.adType;
      loginInfo['user_type'] = (isPatient == "1") ? "patient" : "account_user";

      if (loginInfo["ad_type"] == "OAuth2") {
        const code = this.route.snapshot.queryParamMap.get('code');
        const codeVerifier = localStorage.getItem('kc_code_verifier');
        loginInfo["code"] = code;
        loginInfo["code_verifier"] = codeVerifier;
        loginInfo["redirect_uri"] = window.location.origin + '/sso-redirect';
        loginInfo['account_url'] = this.headerInfo?.main_account?.account_url || window.location.hostname;
        localStorage.removeItem('kc_state');
        localStorage.removeItem('kc_code_verifier');
      }
    }
    //console.log(CryptoJS.AES.decrypt(loginInfo['login_id'], loginInfo['account_url']).toString(CryptoJS.enc.Utf8));
    
    if(this.appService.checkNativeApp()){
      loginInfo['user_agent'] = 'native';
    }else{
      if (this.utilService.isMobile()) {
        loginInfo['user_agent'] = 'mobile';
      } else {
        loginInfo['user_agent'] = 'web'
      }
    }
    var menuParser: any = false;
    try {
      if (this.appService._appData.DECORATOR_DEF['menuParseDecorator'] != undefined) {
        menuParser = new this.appService._appData.DECORATOR_DEF['menuParseDecorator']();
      }
    } catch (e) {
      console.warn(e)
    }
    if (this.baseService.checkKioskApp()) {
      loginInfo['is_kiosk'] = true; // check if kiosk is available and assign KIosk patient role to the user
    }

    this.baseService.add(loginInfo, 'login').subscribe(
      (data: any) => {
        // this.loading = false;
        this.submitted = false;
        if (data.errCode == -1) {
          this.loader.hideSpinner();
          this.config.loading = false;         
          if (this.config.isADredirect) {
            if(loginInfo['user_type'] == "patient"){
              if (data.message == 'USER_NOT_EXISTS_IN_KX') {
                this.config.isADredirect = false;
                this.config.loginWithOther = true;
                this.selfRegistration();
              } else {
                this.alerts.error(data.message);
                setTimeout(()=>{
                  this.redirectToLogin();
                },500)
                
              }
            }else{
              this.alerts.error(data.message);
              setTimeout(()=>{
                this.redirectToLogin();
              },500)
            }
          }else{
            if (data.message != 'USER_NOT_EXISTS_IN_KX') {
              this.alerts.error(data.message);
            }
          }
        } else {
          if (data.resource != undefined && data.resource.length && data.resource[0].mfa_type != undefined && data.resource[0].mfa_type) {
            this.config.loading = false;
            this.mfa = data.resource[0].mfa_type;
            if (this.mfa != 'pin') {
              this.mfaConfig['length'] = 6;
              this.showTimer = true;
              this.resendOTPVar = false;
              this.timerFn();
            }
            this.loader.hideSpinner();
          }
          else if (data.resource != undefined && data.resource.length) {
            let newData = this.loginservice.decryptLoginInfo(data);
            this.loginservice.buildApplication(newData, menuParser);
            //no loading false set here because we don't want login api to hit again if successfull login
          } else {
            this.alerts.error(data.message);
            this.loader.hideSpinner();
            this.config.loading = false;
            if (this.config.isADredirect) {
              this.redirectToLogin();
            }
          }
        }
        //this.loader.hideSpinner();
      }, error => {
        console.log(error);
        this.alerts.error('API error');
        //this.loading = false;
        this.submitted = false;
        this.loader.hideSpinner();
        this.config.loading = false;
        if (this.config.isADredirect) {
          this.redirectToLogin();
        }
      }
    );
  }

  onOtpChange(otp) {
    this.otp = otp;
  }
  back() {
    this.mfa = false;
  }

  timerFn() {
    this.timer = 60;
    this.showTimer = true;
    let timerInterval = setInterval(() => {
      this.timer -= 1;
      if (this.timer <= 0) {
        clearInterval(timerInterval);
        this.showTimer = false;
      }
    }, 1000)
  }

  generatePin() {
    let data = {};
    data["generatePin"] = true;
    data["loginForm"] = this.loginForm.value
    data["isKarexpert"] = this.isKarexpert
    let args = 'login_id:' + this.loginForm.value.login_id + ',account_url:' + (this.isKarexpert ? this.loginForm.value.account_url : window.location.hostname) + ',context:forget_pin';
    this.baseService.get('send_otp', args, 'send_otp', 'account-management').subscribe(result => {
      this.loader.hideSpinner()
      if (result.errCode == 0) {
        this.alerts.success(result.message);
      }
      else {
        this.alerts.error(result.message);
      }
    })
    this.dialogService.open(DemographicOtpVerifyComponent, { size: DialogModalSize.Md, data: data }).afterClosed.subscribe(
      response => {
        console.log("popup is closed")
        //   this.router.navigate([])
      })
  }

  languageChange(value) {
    this.translateService.setLanguage(value, () => {
      window.location.reload();
    });
  }

  forgotPassword() {
    console.log('forgot password clicked');
    if (!(this.authenticationService.getCurrentUser())) {
      this.router.navigate(['/forgotpass']);
    }
  }

  onlinePayment() {
    this.router.navigate(['/online-payment']);
  }
  
  logInMobile() {
    this.logInWithMobile = true;
    this.logInWith = 'OTP';
    this.router.navigateByUrl('/account-management/loginwithotp');
  }

  logInMobileKiosk() {
    this.logInWithMobile = true;
    this.logInWith = 'OTP';
    this.router.navigateByUrl('/account-management/loginwithotpkiosk');
  }

  logInPin() {
    this.logInWithMobile = true;
    this.logInWith = 'PIN';
    this.router.navigateByUrl('/account-management/loginwithpin');
  }

  showTnc(user?) {
    console.log('show tnc clicked');
    let data = {
      label : user
    }
    this.modalService.open(TncComponent, data , 'Terms of Service and Data Privacy Notice', ModalSize.Lg, 'center', true).subscribe(res => {
      if (res) {
        console.log('tnc modal closed');
      }
    }, err => {
      console.error('error occured in tnc modal', err);
    })
  }

  selfRegistration() {
    this.registerUser = true;
    this.logInWithMobile = false;
  }
  loginBack() {
    this.registerUser = false;
  }

  backToLogin(event) {
    if (event.back == true || event.set_password == true)
      this.registerUser = false;
    this.logInWithMobile = this.checkurl();
    // if(this.checkurl()){
    //   this
    // }
    if (this.adService.adObj.adConfigs.length > 0 && this.config.loginWithOther) {
      this.config.loginWithOther = false;
    }
  }
  installApp() {
    this.loginservice.installApp();
  }

  /************ AD IMPLIMENATION ********/
  initloginWithAD() {
    if (this.adService.adObj.instances != undefined && this.adService.adObj.instances[this.config.adType] != undefined) {
      this.adService.adObj.instances[this.config.adType].adClient.handleRedirectPromise()
        .then((response) => {
          if (response !== null) {
            this.setAdObj(response);
          } else {
            var userHint = localStorage.getItem("ad_user");
            if (userHint != null) {

              const silentRequest = {
                scopes: this.adService.adObj.instances[this.config.adType].scope,
                loginHint: userHint
              };
              this.adService.adObj.instances[this.config.adType].adClient.ssoSilent(silentRequest).
                then((response) => {
                  this.setAdObj(response);
                }).catch(error => {
                  console.error("Silent Error: ", error);
                  this.redirectToLogin();
                });
            } else {
              //redirect to login
              this.redirectToLogin();
            }
          }
        })
        .catch((error) => {
          console.error(error);
          this.redirectToLogin();
        });
    }
  }

  checkKioskSelfRegister(){
    return this.baseService.checkKioskApp()?true:false;
  }

  setAdObj(response) {
    localStorage.setItem("ad_user", response.account.username)
    localStorage.setItem("ad_ac", response.account.homeAccountId)
    localStorage.setItem("ad_name", response.account.name)
    localStorage.setItem("ad_type", this.config.adType)
    console.log(response);
    this.adLogin(response);
  }
  removeAdObj() {
    // If earlier redirected to SSO login then resetting the login id/password 
    if (this.loginForm && this.loginForm.controls != undefined && this.loginForm.controls) {
        let login_id = this.loginForm.controls['login_id'];
        let password = this.loginForm.controls['password'];
        if (login_id != undefined && login_id.value != undefined && login_id.value)
            this.loginForm.controls['login_id'].setValue("");
        if (password != undefined && password.value != undefined && password.value)
            this.loginForm.controls['password'].setValue("");
    }
    this.adService.removeAdObj();
  }

  redirectToLogin() {
    this.baseService.redirectToLogin();
  }




  redirectToADLogin(type) {
    if (this.config.isPatient) {
      localStorage.setItem("ad_patient", "1");
    }else{
      localStorage.removeItem("ad_patient")
    }
    this.adService.loginWithAD(type);
  }
  adLogin(response) {
    if (this.isKarexpert != '') {
      this.loginForm.controls['account_url'].setValue(prompt("Please enter Account Url"));
    } else {
      this.loginForm.controls['account_url'].setValue(window.location.hostname);
    }
    this.loginForm.controls['login_id'].setValue(response.account.username);
    this.loginForm.controls['password'].setValue(response.accessToken);
    this.registerConfig.accessToken = response.accessToken;
    this.registerConfig.fullName = this.parseName(response.account.name);
    this.registerConfig.adType = this.config.adType;
    this.onSubmit();
  }

  parseName(name){
    try{
      if(name && name != ""){
        var nameAr = name.split(" (");
        if(nameAr.length>0){
          name = nameAr[0].replace("EXTERNAL","").replace("FIXED-TERM", "");
        }
        name = this.removeSpecialCharacters(name);
      }
      return name;
    }catch(e){
      console.error(e);
      return name;
    }    
  }

  removeSpecialCharacters(str) {
    return str.replace(/[^a-zA-Z0-9 ]/g, '').trim();
  }

  checkCapsLock(event: KeyboardEvent): void {
    this.isCapsLockOn = event.getModifierState && event.getModifierState('CapsLock');
  }

  getCaptcha() {
    this.loginservice.getCaptchaResourceDef((question) => {
      if (question) {
        (this.loginForm.get('captcha') as any).question = question;
        this.show_captcha = true;
        this.getCaptchaStyle();
      }
    });
  }

  getCaptchaStyle() {
    this.loginservice.getCaptchaStyle(this.elementRef, this.renderer);
  }

  processOAuth2Redirect() {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const returnedError = this.route.snapshot.queryParamMap.get('error');
    const storedState = localStorage.getItem('kc_state');
    const codeVerifier = localStorage.getItem('kc_code_verifier');
    

    if (returnedError) {
      this.alerts.error(this.route.snapshot.queryParamMap.get('error_description') || returnedError);
      this.redirectToLogin();
      return;
    }
    if (!code || !state || state !== storedState || !codeVerifier) {
      this.redirectToLogin();
      return;
    }

    const providerConfig = this.adService.getPrimaryProviderConfig();
    if (!providerConfig || !providerConfig.client_id || !providerConfig.token_endpoint) {
      this.redirectToLogin();
      return;
    }
    this.onSubmit();
    // this.baseService.add(requestBody, 'sso_login').subscribe((response: any) => {
    //   this.loader.hideSpinner();
    //   const loginResponse = this.normalizeSsoLoginResponse(response);
    //   if (loginResponse && loginResponse.login_id && loginResponse.access_token) {
    //     this.adLogin({
    //       account: {
    //         username: loginResponse.login_id,
    //         name: loginResponse.full_name
    //       },
    //       accessToken: loginResponse.access_token
    //     });
    //   } else {
    //     if (response && response.message) {
    //       this.alerts.error(response.message);
    //     }
    //     this.redirectToLogin();
    //   }
    // }, error => {
    //   console.error(error);
    //   this.loader.hideSpinner();
    //   this.alerts.error('SSO login failed.');
    //   this.redirectToLogin();
    // });
  }

  /************ AD IMPLIMENATION ********/

  // logout() {
  //   this.loader.showSpinner()
  //   var application = this.appService._appData.DEFAULT_APPLICATION;
  //   var currentResource = "logout";
  //   var args = "";
  //   var postData = this.baseService.getEncodedData({}, "", application, "");
  //   var options: any = this.baseService.addXsrfToken(postData.encodedResourceData);
  //   var url = this.baseService.getApiEndpoint(application) + currentResource + args;
  //   this.baseService._http.post(url, postData.params, options).subscribe();
  //   this.loader.hideSpinner()
  // }
}